import {createEntityAdapter, EntityAdapter} from '@ngrx/entity';
import {LandExtended} from '../../interfaces/land-extended.interface';


export const landEntitiesAdapter: EntityAdapter<LandExtended> = createEntityAdapter<LandExtended>({
  selectId: (LandEntity: LandExtended) => LandEntity.betriebId + '-' + LandEntity.isoAlpha2!,
});
